<template>
  <div
    class="ct-tab-block"
    v-html="tab?.contentBlock"
  />
</template>

<script setup lang="ts">
import type { Tab } from "@/types/entrypoints"

defineProps<{
	tab?: Tab
}>()
</script>

<style lang="postcss" scoped>
@reference '#importtailwindcss';

.ct-tab-block {
  > div {
    @apply flex flex-col gap-12 ;
  }
}
</style>
